import request from '@/api/request';
import { createModel } from '@rematch/core';
import type { RematchRootState } from '@rematch/core';
import type { RootModel, Curve, CurvesState, DispatchRematch } from '@/components/WellLoggingOperations/types';

export const curvesModel = createModel<RootModel>()({
    name: 'curves',
    state: {
        data: {},
        isLoading: false,
        error: null,
    } as CurvesState,
    reducers: {
        setCurves(state, payload: Record<string, Curve>) {
            return { ...state, data: { ...state.data, ...payload }, isLoading: false };
        },
        setNewCurves(state, payload: Record<string, Curve>) {
            return { ...state, data: { ...payload }, isLoading: false };
        },
        setLoading(state) {
            return { ...state, isLoading: true };
        },
        setError(state, err) {
            const message = err?.message ?? String(err);
            return { ...state, error: message, isLoading: false };
        },
    },

    effects: (dispatch: any) => ({
        async loadCurves(newCurve: { ids: number[]; columnIndex: number }, rootState: RematchRootState<RootModel>) {
            // Оптимизация
            const loadedIds = Object.keys((rootState.curves as CurvesState).data);
            const curveIds = newCurve?.ids?.filter(id => !loadedIds.includes(String(id))) ?? [];

            const incId = rootState.inclinometry.activeVersionID;

            const body = {
                curves: curveIds,
                inclinometryId: incId,
            };
            if (curveIds.length) {
                // @ts-ignore
                this.setLoading();

                (dispatch as DispatchRematch).tablets.incrementingCurrentRequests();

                try {
                    const result = await request.get(`logging/curve-data/?params=${JSON.stringify(body)}`);
                    /* eslint-disable */
                    const data = (await result.json()) as Curve[];

                    const curves = data.reduce(
                        (a, c) => ({ ...a, [c.id]: { ...c, columnIndex: newCurve.columnIndex } }),
                        {} as Record<string, Curve>,
                    );

                    // @ts-ignore
                    this.setCurves(curves);
                } catch (error) {
                    // @ts-ignore
                    this.setError(error);
                }

                (dispatch as DispatchRematch).tablets.decrementingCurrentRequests();
            }
        },
    }),
});
